<template>
  <div>
    <div v-show="!onChild">
      <table-title>账单列表</table-title>
      <!-- 查询 -->
      <div class="serach">
        <Form ref="formValidate" :label-width="125" inline>
          <div>
            <FormItem label="参与人">
              <payee-select class="shrug" roleType="LEASEE" v-model="queryParams.memberId"></payee-select>
            </FormItem>
            <FormItem label="合伙人">
              <!-- <payee-select class="shrug" roleType="LEASER" v-model="queryParams.leaserId"></payee-select> -->
              <partner-select v-model="queryParams.leaserId" />
            </FormItem>
            <FormItem label="账单状态">
              <dict-select v-model="queryParams.status" namespace="default" id="leaseBillStatus" :exclusion="[]" />
            </FormItem><br>
            <FormItem label="账单类型">
              <dict-select v-model="queryParams.billType" namespace="default" id="billType" :exclusion="[]" />
            </FormItem>
            <FormItem label="账单日">
              <DatePicker type="daterange" placement="bottom-end" placeholder="请选择时间范围" @on-change="onDateChang" style="width: 200px" transfer></DatePicker>
            </FormItem>
            <Button type="primary" style="margin-left:20px" @click="getQuery">查询</Button>
          </div>
        </Form>
      </div>
      <!-- 列表 -->
      <div class="table">
        <data-grid ref="dg" :columns="cols" :queryParams="queryParams" paramsName="params" :pageNum="1" :pageSize="20" :queryUrl="queryUrl" exportId="queryBillListByParam" exportFileName="租赁账单">
          <template #default="{columns, data}">
            <Table :columns="columns" :data="data" border stripe size="small" highlight-row>
              <template slot-scope="{ row }" slot="action">
                <Button size="small" type="success" @click="showDetail(row)">详情</Button>
                <Button v-if="row.status=='00'" size="small" type="primary" v-show="confirmButton" @click="rebuild(row)">重新清算</Button>
                <Button style="margin-left:5px" size="small" type="info" @click="downloadAttachment(row)">下载附件</Button>
              </template>
            </Table>
          </template>
        </data-grid>
      </div>
    </div>
    <billDetal v-if="onChild" :paramsData="currentRow" @on-finish="onFinish"></billDetal>
  </div>
</template>
<script>
import { saveFile } from '@/libs/utils/localUtil.js'

import tableTitle from '@/components/tableTitle/tableTitle.vue'

import dataGrid from '@/components/datagrid.vue';
import dictSelect from '@/components/select/dict-select.vue';
import payeeSelect from '@/components/select/payee-select.vue';
import billDetal from './component/bill-detail.vue';
import partnerSelect from '@/components/select/partner-select.vue';

export default {
  components: {
    tableTitle,
    dataGrid,
    dictSelect,
    payeeSelect,
    billDetal,
    partnerSelect
  },
  data() {
    return {
      confirmButton: false,//重新清算按钮权限限制
      queryUrl: 'http://CORE-CONTRACT/messageService/queryService/queryBillListByParam',
      cols: [
        { title: '账单ID', key: 'id', width: '100px' },
        { title: '参与人', key: 'memberId', dict: ['bizObjects', 'member', true], width: '150px' },
        { title: '合伙人', key: 'leaserId', dict: ['bizObjects', 'member', true], width: '150px' },
        { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true], width: '120px' },
        { title: '账单日', key: 'billDate', width: '80px' },
        { title: '账单开始日', key: 'billStartDate', width: '80px' },
        { title: '账单截止日', key: 'billEndDate', width: '80px' },
        { title: '账单类型', key: 'billType', dict: ['default', 'billType'], width: '80px' },
        { title: '账单含税', key: 'taxedFlag', dict: ['default', 'bitYesNo'], width: '50px' },
        { title: '租费', key: 'rentalFee', width: '80px' },
        { title: '服务费', key: 'serviceFee', width: '80px' },
        { title: '配送费', key: 'deliverFee', width: '80px' },
        { title: '回收费', key: 'recycleFee', width: '80px' },
        { title: '清洗费', key: 'cleanFee', width: '80px' },
        { title: '转户费', key: 'transFee', width: '80px' },
        { title: '赔偿金', key: 'compensationFee', width: '80px' },
        { title: '收益', key: 'profitFee', width: '80px' },
        { title: '剩余计租数', key: 'endStock', width: '80px' },
        { title: '财务账单id', key: 'financeBillId', width: '80px' },
        { title: '收益清算编号', key: 'leaseholdClearId', width: '80px' },
        { title: '状态', key: 'status', dict: ['default', 'leaseBillStatus'], width: '50px' },
        { title: '办理', slot: 'action', width: '150px',fixed:"right" },

      ],
      queryParams: {
        memberId: "",
        leaserId: "",
        status: ""
      },
      currentRow: {},
      onChild: false
    }
  },
  mounted() {
    this.getButton()
  },
  methods: {
    //   下载附件
    async downloadAttachment(row) {
      await this.invalidMerge([row.id]);
      let params = {
        body: { billIdList: [row.id] }
      };
      let result = await this.request('/exportBillCheckExcel', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, responseType: 'arraybuffer' });
      let memberName = this.$options.filters['queryDict']('bizObjects', 'member', row.memberId);
      let targetTypeName = this.$options.filters['queryDict']('target', 'type', row.targetType);
      let name = memberName + '(' + targetTypeName + ')' + row.billDate;
      console.log(result)
      saveFile(name + '账单.xlsx', result);
    },
    async invalidMerge(billIdList) {
      let data = {
        url: "CORE-CONTRACT/messageService/billService/invalidBillMerge",
        body: { billIdList: billIdList }
      }
      let flag = await this.invoke(data);
      if (!flag) {
        throw new Error("校验失败");
      }
    },
    // 重新清算按钮限制
    getButton() {
      this.confirmButton = JSON.parse(sessionStorage.getItem('menuList')).some(item => item === 'billListMenuReclearButton');
    },
    onDateChang(val) {
      this.queryParams.startDate = val[0];
      this.queryParams.endDate = val[1];
    },
    getQuery() {
      this.$refs['dg'].loadFirstPage()
    },
    showDetail(row) {
      this.currentRow = row;
      this.onChild = true;
    },
    rebuild(row) {
      let okFn = () => {
        let params = {
          url: 'http://CORE-CONTRACT/messageService/billService/rebuildBill',
          body: {
            billId: row.id,
          }
        }
        this.invoke(params).then((rs) => {
          if (rs) {
            this.$Message.info('清算成功!');
            this.getQuery();
          }
        });
      }
      this.$Modal.confirm({
        title: '重新清算',
        content: '同期其他标的物小类的账单也将重新清算?',
        onOk: okFn
      })

    },
    onFinish() {
      this.getQuery();
      this.onChild = false;
    }
  }

}
</script>